import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import {
  getInitFormData,
  getAutoSlip,
  getTablebySql,
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global, ExecuteRunner } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnCodeBox from "@shared/components/SnCodeBox";
import SnLabel from "@shared/components/SnLabel";
import SnDateBox from "@shared/components/SnDateBox";
import SnButton from "@shared/components/SnButton";
import CommonSpinner from "@widgets/CommonSpinner";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
interface Props {
  Menuprops: menuInfo;
}
interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_MTL_ISU_REG_003 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const gridApiRef2 = useRef<any>(null); // 두 번째  그리드 Reference 변수
  const gridApiRef3 = useRef<any>(null);

  const gridApiRef4 = useRef<any>(null);

  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global(); // Login user 정보
  //#endregion

  const popDate = new Date();
  popDate.setDate(1);
  const firstDayOfMonth = `${popDate.getFullYear()}${(popDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${popDate.getDate().toString().padStart(2, "0")}`;
  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns1, setColums1] = useState<any[]>([]); // gridApiRef1 컬럼 설정 관련
  const [columns2, setColums2] = useState<any[]>([]);
  const [columns3, setColums3] = useState<any[]>([]);
  const [columns4, setColums4] = useState<any[]>([]); // gridApiRef2 컬럼 설정 관련
  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRef1 datasource 관련
  const [dataSource2, setDataSource2] = useState<any>(); //
  // gridApiRef2 datasource 관련
  const [dataSource3, setDataSource3] = useState<any[]>([]); // gridApiRef1 datasource 관련
  const [dataSource4, setDataSource4] = useState<any>(); //
  const [dateBox, setDateBox] = useState<string>(todayform);
  //#endregion
  const [codeWh, setCodeWh] = useState<string>("");
  const [codeEmp, setCodeEmp] = useState<any>(userInfo.cd_emp || "");
  //const [selectedTabPage, setTapPage] = useState<string>("1");
  const [loading, setLoading] = useState<boolean>(false);
  const selectedTabPage = useRef<string>("1");
  const [gridFocus, setGridFocus] = useState(false);
  //#endregion
  const cd_menu = Menuprops.cd_menu || "SN_MTL_ISU_REG_003";
  const defaultSize = {
    panel1height: "49.5%",
    panel2height: "49.5%",
    panel3height: "49.5%",
    panel4height: "49.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      setDataSource2([]);
      setDataSource3([]);
      setDataSource4([]);
      try {
        const defaultForm = {
          cd_biz: userInfo.cd_biz,
          dt_from: firstDayOfMonth,
          dt_to: todayform,
        };
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData({ ...rtn.formData, ...defaultForm });
        setColums1(rtn.grid.grid1); // H그리드 항목 설정
        setColums2(rtn.grid.grid2);
        setColums3(rtn.grid.grid3);
        setColums4(rtn.grid.grid4);
      } catch (error) {}
    };
    fetchform();
  }, []);
  useEffect(() => {
    if (selectedTabPage.current === "1") {
      gridApiRef1.current.selectAndFocusRow(0);
    } else {
      gridApiRef3.current.selectAndFocusRow(0);
    }
    setGridFocus(false);
  }, [gridFocus]);

  useImperativeHandle(ref, () => ({
    onSearch,
    onExecute,
  }));
  //#region onSearch
  const onSearch = async () => {
    try {
      if (selectedTabPage.current === "1") {
        const params = {
          id: "sn_mtl_isu_reg_003_01",
          params: searchRef.current.getFormdata(),
        };
        setDataSource1([]);
        setDataSource2([]);
        setDataSource3([]);
        setDataSource4([]);
        const data: any = await fnGetDataSet(params);
        setDataSource1(data[0]);
        setDataSource2(data[1]);

        if (data[0] && data[0].length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));

          setGridFocus(true);
        }
        gridApiRef1.current.resetUpdate();
        gridApiRef2.current.resetUpdate();
      } else {
        const params2 = {
          id: "sn_mtl_isu_reg_003_02",
          params: searchRef.current.getFormdata(),
        };

        setDataSource1([]);
        setDataSource2([]);
        setDataSource3([]);
        setDataSource4([]);

        const data: any = await fnGetDataSet(params2);
        setDataSource3(data[0]);
        setDataSource4(data[1]);

        if (data[0] && data[1].length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));

          setGridFocus(true);
        }
        gridApiRef3.current?.resetUpdate();
        gridApiRef4.current?.resetUpdate();
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //#region onExecute

  const onExecute = async (id: string) => {
    try {
      switch (id) {
        case "Save":
          {
            if (dateBox === "" || dateBox === null) {
              showDialog("alter", "날짜가 입력되지 않았습니다.");
              return;
            }
            if (codeEmp === "") {
              showDialog("alter", "정리 담당자가 입력되지 않았습니다.");
              return;
            }
            const sqlQuery2 = {
              sql: "select cd_dept from mas_emp where cd_firm = :cd_firm and cd_emp = :cd_emp",
              cd_firm: userInfo.cd_firm,
              cd_emp: codeEmp,
            };

            const params = await getTablebySql(sqlQuery2);

            const mtlQtoH: any[] = [];
            const mtlQtoL: any[] = [];

            const displayedNodes = gridApiRef1.current.api.getRenderedNodes();
            const cd_wh2 = codeWh;

            const allNodes: any[] = [];

            displayedNodes.forEach((node: any) => {
              if (node.isSelected()) {
                allNodes.push(node);
              }
            });

            if (allNodes.length === 0) return;

            for (const parentNode of allNodes) {
              const allNodesofChild: any[] = [];

              gridApiRef2.current.api.forEachNode((childNode: any) => {
                if (childNode.data?.no_req === parentNode.data?.no_req) {
                  allNodesofChild.push(childNode);
                }
              });

              if (allNodesofChild.length === 0) continue;

              for (const node of allNodesofChild) {
                const qt_rcv =
                  (node.data?.qt_good ?? 0) + (node.data?.qt_bad ?? 0);

                if (cd_wh2 === "" && !node.data?.cd_wh) {
                  showDialog(
                    "alter",
                    "정리목록 중 창고 미입력 건에 대해 처리할 정리창고가 입력되지 않았습니다."
                  );
                  return;
                }

                if (qt_rcv > (node.data?.qt ?? 0)) {
                  showDialog(
                    "alter",
                    " 정리목록 중 출고수량이 의뢰수량보다 많은 건이 있습니다."
                  );
                  return;
                }

                const qtioL = {
                  cd_firm: userInfo.cd_firm,
                  no_io: "",
                  no_line: node.data?.no_line,
                  cd_biz: parentNode.data?.cd_biz,
                  cd_io: parentNode.data?.cd_io,
                  fg_slip: parentNode.data?.fg_slip,
                  tp_slip: parentNode.data?.tp_slip,
                  fg_io: parentNode.data?.fg_io,
                  fg_money: parentNode.data?.fg_money,
                  cd_item: node.data?.cd_item,
                  qt: node.data?.qt ?? 0,
                  qt_good: node.data?.qt_good ?? 0,
                  qt_bad: node.data?.qt_bad ?? 0,
                  qt_cls: node.data?.qt_cls,
                  um: node.data?.um ?? 0,
                  um_k: node.data?.um_k ?? 0,
                  am: node.data?.am ?? 0,
                  am_k: node.data?.am_k ?? 0,
                  am_vat: node.data?.am_vat ?? 0,
                  um_supply: node.data?.um_supply ?? 0,
                  am_supply: node.data?.am_supply ?? 0,
                  fg_vat: node.data?.fg_vat,
                  no_line_order: node.data?.no_line_so,
                  no_line_req: node.data?.no_line,
                  no_req: node.data?.no_req,
                  cd_wh: "",
                  dc_rmk: node.data?.dc_rmk,
                  dt_rtn_plan: node.data?.dt_rtn_plan,
                  dt_io: dateBox,
                  rt_exch: parentNode.data?.rt_exch,
                  fg_map: "1",
                };

                if (node.data?.cd_wh === "" && codeWh !== "") {
                  qtioL.cd_wh = codeWh;
                } else {
                  qtioL.cd_wh = node.data?.cd_wh;
                }

                mtlQtoL.push(qtioL);
              }
              const qtioH = {
                cd_firm: userInfo.cd_firm,
                no_io: "",
                cd_biz: parentNode.data?.cd_biz,
                dt_io: dateBox,
                cd_cust: parentNode.data?.cd_cust,
                cd_exch: parentNode.data?.cd_exch,
                rt_exch: parentNode.data?.rt_exch,
                cd_io: parentNode.data?.cd_io,
                fg_slip: parentNode.data?.fg_slip,
                tp_slip: parentNode.data?.tp_slip,
                fg_io: parentNode.data?.fg_io,
                fg_money: parentNode.data?.fg_money,
                fg_trns: parentNode.data?.fg_trns,
                cd_emp: codeEmp,
                cd_dept: params[0]["cd_dept"],
                cd_gp: parentNode.data?.cd_gp,
                cd_pjt: parentNode.data?.cd_pjt,
                cd_mgmtdtl: parentNode.data?.cd_mgmtdtl,
                dc_rmk: parentNode.data?.dc_rmk,
                am: parentNode.data?.am,
                am_k: parentNode.data?.am_k,
                am_vat: parentNode.data?.am_vat,
                am_supply: parentNode.data?.am_supply,
                yn_autoprocess: parentNode.data?.yn_autoprocess,
                no_hst: 0,
                fg_map: "1",
              };

              mtlQtoH.push(qtioH);

              const cd_module: any = Menuprops.cd_module;
              const cd_menu: any = Menuprops.cd_menu;
              try {
                const no_slip = await getAutoSlip(
                  cd_module,
                  10,
                  todayform,
                  cd_menu
                );
                if (no_slip) {
                  for (let row of mtlQtoL) {
                    mtlQtoH[0].no_io = no_slip;
                    row.no_io = no_slip;
                  }
                }
                gridApiRef4.current.applyFilters({ no_io: no_slip });
              } catch (error) {}

              const SaveData = {
                mtl_qtioh: { insert: mtlQtoH },
                mtl_qtio: { insert: mtlQtoL },
              };

              await fnSave("SN_MTL_ISU_REG_003_SAVE_01", SaveData);
              gridApiRef1.current.resetUpdate();
              gridApiRef2.current.resetUpdate();
            }
          }
          break;
        case "Delete": {
          let mtlQtiohChanges;
          let mtlQtioChanges;
          try {
            const getRenderedNodes = gridApiRef3.current.api.getRenderedNodes(); //get display rows of grid

            for (const node of getRenderedNodes) {
              if (!node?.data) continue; //if there is no data
              if (node.isSelected()) {
                if (node.data.yn_autoprocess === "Y") {
                  showDialog("alter", "자동 처리된 건입니다.");
                  return;
                }
              }
            }

            gridApiRef4.current?.deleteAllRows();
            gridApiRef3.current?.deleteSelectedRows();

            mtlQtiohChanges = gridApiRef3.current.getChange();
            mtlQtioChanges = gridApiRef4.current.getChange();
            const SaveData = {
              mtl_qtioh: mtlQtiohChanges,
              mtl_qtio: mtlQtioChanges,
            };
            await fnSave("SN_MTL_ISU_REG_003_SAVE_01", SaveData);
            gridApiRef4.current.resetUpdate();
            gridApiRef3.current.resetUpdate();
          } catch (error: any) {
            if (mtlQtiohChanges.delete?.length > 0) {
              gridApiRef4.current.api.applyTransaction({
                add: mtlQtioChanges.delete,
              });
            }

            if (mtlQtiohChanges?.delete?.length > 0) {
              const res = gridApiRef3.current.api.applyTransaction({
                add: mtlQtiohChanges.delete,
              });

              // 첫 번째 복구된 행 자동 선택 & 포커스 이동
              if (res.add && res.add.length > 0) {
                const firstRestoredRow = res.add[0]; // 첫 번째 복구된 행
                gridApiRef3.current?.selectAndFocusRow(
                  firstRestoredRow.rowIndex
                );
              }

              // 변경 버퍼 초기화 (Insert / Update / Delete 버퍼 리셋)
              gridApiRef3.current.resetUpdate();
              gridApiRef4.current.resetUpdate();
            }
          }
          break;
        }
      }
    } catch (error: any) {}
  };
  //#endregion

  //#region Filter1
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const no_req = selectedRow.no_req;
      gridApiRef2.current.applyFilters({ no_req: no_req });
      gridApiRef2.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  //#region Filter2
  const onFocusedRowChanged2 = (event: any) => {
    const selectedRow2 = event; // 클릭한 행 데이터
    if (selectedRow2) {
      // 배열로 만들어서 필터링 함수 호출
      const no_io = selectedRow2.no_io;
      gridApiRef4.current.applyFilters({ no_io: no_io });
      gridApiRef4.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  //#region onTabChanged
  const onTabChanged = async (index: string) => {
    selectedTabPage.current = index;
    setLoading(true);
    try {
      await onSearch();
    } finally {
      setLoading(false);
    }
  };

  const DateValueChanged = async (value: string) => {
    setDateBox(value);
  };
  const WhValueChanged = async (value: string) => {
    setCodeWh(value);
  };
  const empValueChanged = async (value: string) => {
    setCodeEmp(value);
  };
  const onCellValueChanged = async (event: any) => {
    if (!event) return;

    const updatedRow = event.data;

    // 수정된 컬럼 ID 및 정보
    const updatedColumnId = event.column.getColId(); // 수정된 컬럼의 ID
    const updatedColumnDef = event.colDef; // 수정된 컬럼의 정의
  };

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <CommonSpinner isLoading={loading} />
      <SnTab
        titles={["미처리", "처리"]}
        width={"100%"}
        onTabChanged={onTabChanged}
        header={[
          <SnTabHeader
            body={[
              <div className="relative flex space-x-2">
                <SnLabel text="정리일" type="string" />
                <div style={{ width: 180 }}>
                  <SnDateBox
                    defaultValue={todayform}
                    onValueChanged={DateValueChanged}
                  />
                </div>
                <SnLabel text="정리창고" type="string" />
                <div style={{ width: 180 }}>
                  <SnCodeBox
                    code="POPUP_WH"
                    defaultValue={{
                      code: "",
                      name: "",
                    }}
                    isEditable={true}
                    onValueChanged={WhValueChanged}
                  />
                </div>
                <SnLabel text="정리담당" type="string" />
                <div style={{ width: 180 }}>
                  <SnCodeBox
                    code="POPUP_EMP"
                    defaultValue={{
                      code: userInfo.cd_emp,
                      name: userInfo.nm_emp,
                    }}
                    onValueChanged={empValueChanged}
                    isEditable={true}
                  />
                </div>
                <div style={{ width: 200 }} />
                {/*empty space*/}
                <div style={{ width: 70 }}>
                  <SnButton
                    text={"처리"}
                    onClick={() => {
                      ExecuteRunner.run("Save");
                    }}
                  />
                </div>
              </div>,
            ]}
          />,

          <SnTabHeader
            body={[
              <div>
                <SnButton
                  text={"취소"}
                  onClick={() => {
                    ExecuteRunner.run("Delete");
                  }}
                />
              </div>,
            ]}
          />,
        ]}
        body={[
          <div className="flex-1 h-full min-h-0 space-y-1.5">
            <SnResizable
              direction={"height"}
              seq={1}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panel1height}
              onResizeStop={onResizeStop}
              enable={{ bottom: true }}
              minHeight={130}
            >
              <SnGrid
                // Pros로 받은 Menuprops
                seq={1} // Grid Seqno 우클릭 메뉴용
                ref={gridApiRef1} // Grid Name
                columnConfig={columns1} // 컬럼 설정 전달
                rowData={dataSource1} // Datasource
                isEditable={true} // 수정 가능여부
                rowSelection="single" // 로우 선택 모드 (단일)
                onFocusedRowChanged={onFocusedRowChanged}
                resizeController={{
                  defaultSize: defaultSize,
                  onResizeStop: onResizeStop,
                }}
              />
            </SnResizable>
            <SnResizable
              direction={"height"}
              seq={2}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panel2height}
              onResizeStop={onResizeStop}
              enable={{ bottom: true }}
              minHeight={130}
            >
              <SnGrid
                // Pros로 받은 Menuprops
                seq={2} // Grid Seqno 우클릭 메뉴용
                ref={gridApiRef2} // Grid Name
                columnConfig={columns2} // 컬럼 설정 전달
                rowData={dataSource2} // Datasource
                enableExternalChart={false} // 하단 기본 차트 생성 여부
                // chartColumns={["qt", "am"]} // 차트 생성 기준 칼럼 설정
                isEditable={true} // 수정 가능여부
                rowSelection="multiple" // 로우 선택 모드(멀티)
                onCellValueChanged={onCellValueChanged}
                resizeController={{
                  defaultSize: defaultSize,
                  onResizeStop: onResizeStop,
                }}
              />
            </SnResizable>
          </div>,

          <div className="flex-1 h-full min-h-0 space-y-1.5">
            <SnResizable
              direction={"height"}
              seq={3}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panel3height}
              onResizeStop={onResizeStop}
              enable={{ bottom: true }}
              minHeight={130}
            >
              <SnGrid
                // Pros로 받은 Menuprops
                seq={3} // Grid Seqno 우클릭 메뉴용
                ref={gridApiRef3} // Grid Name
                columnConfig={columns3} // 컬럼 설정 전달
                rowData={dataSource3} // Datasource
                isEditable={true} // 수정 가능여부
                rowSelection="single"
                onFocusedRowChanged={onFocusedRowChanged2}
                resizeController={{
                  defaultSize: defaultSize,
                  onResizeStop: onResizeStop,
                }}
              />
            </SnResizable>
            <SnResizable
              direction={"height"}
              seq={4}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panel4height}
              onResizeStop={onResizeStop}
              enable={{ bottom: true }}
              minHeight={130}
            >
              <SnGrid
                // Pros로 받은 Menuprops
                seq={4} // Grid Seqno 우클릭 메뉴용
                ref={gridApiRef4} // Grid Name
                columnConfig={columns4} // 컬럼 설정 전달
                rowData={dataSource4} // Datasource
                enableExternalChart={false} // 하단 기본 차트 생성 여부
                // chartColumns={["qt", "am"]} // 차트 생성 기준 칼럼 설정
                isEditable={true} // 수정 가능여부
                rowSelection="multiple" // 로우 선택 모드(멀티)
                resizeController={{
                  defaultSize: defaultSize,
                  onResizeStop: onResizeStop,
                }}
              />
            </SnResizable>
          </div>,
        ]}
      />
    </div>
  );
  //#endregion
});

export default SN_MTL_ISU_REG_003;
